// import { ProgramFeaturesButton, YearMonthField } from '../components/customs';

import { EFieldType, EStaticType, IFieldElement, IStaticElement } from '../types/calculator';
import { SelectField } from '../components/SelectField';
import { ChipsField } from '../components/ChipsField';
import { RadioField } from '../components/RadioField';
import { SwitchField } from '../components/SwitchField';
import { InputNumberField } from '../components/InputNumberField';
import { InputWithOptions } from '../components/InputWithOptions';
import { SuggestField } from '../components/SuggestField/SuggestField';
import { ProgramFeaturesButton, YearMonthField } from '../components/customs';
import { MoreFiltersButton } from '../components/customs/MoreFiltersButton';

/**
 * Филды (инпуты) формы
 */
export const fieldsMapper = (element: IFieldElement) => {
  {
    switch (element.type) {
      case EFieldType.Select:
        return SelectField;
      case EFieldType.Suggest:
        return SuggestField;
      case EFieldType.Chips:
        return ChipsField;
      case EFieldType.Radio:
        return RadioField;
      case EFieldType.Switch:
        return SwitchField;
      case EFieldType.InputNumber:
        return InputNumberField;
      case EFieldType.InputWithOptions:
        return InputWithOptions;
      case EFieldType.YearMonthField:
        return YearMonthField;
      default:
        return ChipsField;
    }
  }
};

/**
 * Статические элементы формы (все, что не является филдами)
 */
export const staticMapper = ({ type }: IStaticElement) => {
  switch (type) {
    case EStaticType.ProgramFeaturesButton:
      return ProgramFeaturesButton;
    case EStaticType.MoreFiltersButton:
      return MoreFiltersButton;
    default:
      return ProgramFeaturesButton;
  }
};
